import React, { useState } from "react";
import _ from "lodash";
import { useController, Controller } from "react-hook-form";


export const Input = React.forwardRef((props, ref) => {
  const { field } = useController(props);
  const [focusState, setFocusState] = useState(false);
  const { title, style,isHighLight=false, type, errors, defaultValue, customStyle, onChange, ellipses,isDisabled=false, ...others } = props;
  let err = _.get(errors, props.name)
  return (

    <div ref={ref} className="w-full">
        <label className={`text-start block text-sm font-medium leading-6 text-gray-900 ${props?.rules && err ? "text-red-600" : "text-gray-600"}`}>
            {title} {props?.rules?.required?.value === true && <span className="text-red-500 mt-10">*</span>}
        </label>
        <div className={`${customStyle ? customStyle : ''} bg-white focus-within:bg-white outlineStyle rounded ${props?.rules && err ? "focus-within:border-red-600 border-red-600" : ""} `}>
            <Controller
                name={props?.name}
                control={props?.control}
                rules={props?.rules}
                defaultValue={defaultValue}
                render={({ field }) => (
                    <input
                    {...props}
                    {...field}
                    onBlurCapture={() => setFocusState(false)}
                    onFocus={() => setFocusState(true)}
                    autoComplete="off"
                    onChange={e => {
                        field.onChange(e.target.value);
                        if (props.onChange) {
                        props.onChange(e, props?.name);
                        }
                    }}
                    min={type === "number" && !props.min ? 0 : props.min}
                    disabled={isDisabled ? isDisabled :false}
                    placeholder={props.placeholder ? props.placeholder : ''}
                    value={field.value}
                    className={`${props.inputWidthCls ? props.inputWidthCls : 'w-full'} ${type === 'color' ? "h-full" : "p-1"} ${isDisabled && "bg-gray-50 cursor-not-allowed"}  ${isHighLight && "bg-highLight"} block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-gray-600 sm:text-sm sm:leading-6`} {...others}/>
                )}
            />
        </div>
        {props.rules && err &&
            <p className="text-xs text-red-600 h-3 text-start" id="email-error">
                {props.rules && err && (
                    props.rules && err?.message
                )}
            </p>
        }
    </div>
  );
});